import * as React from 'react';
import { Waypoint } from 'react-waypoint';
import MediaQuery from 'ha/helpers/MediaQuery';

interface Props {
  render?: (props: { hasEntered: boolean }) => React.ReactNode;
  children?: React.ReactNode;
  placeholder?: React.ReactNode;
}

interface DefaultProps {
  placeholder: React.ReactNode;
}

interface State {
  hasEntered: boolean;
}

const LazyComponent: React.ComponentClass<
  Props & Waypoint.WaypointProps
> = class extends React.Component<
  Props & Waypoint.WaypointProps & DefaultProps,
  State
> {
  static defaultProps: DefaultProps = {
    placeholder: null,
  };

  state: State = {
    hasEntered: false,
  };

  handleEnter: Waypoint.WaypointProps['onEnter'] = args => {
    this.setState({ hasEntered: true });
  };

  renderChildren = () => {
    const { render, children, placeholder } = this.props;
    const { hasEntered } = this.state;

    if (render) {
      return render({ hasEntered });
    }

    return hasEntered ? children : placeholder;
  };

  render() {
    const { children, placeholder, ...rest } = this.props;

    return (
      <MediaQuery>
        {({ lg }) => (
          <Waypoint
            {...(lg ? {} : { scrollableAncestor: 'window' })}
            {...rest}
            onEnter={this.handleEnter}
          >
            {this.renderChildren()}
          </Waypoint>
        )}
      </MediaQuery>
    );
  }
};

export default LazyComponent;
